<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light main-color">
      <span class="mr-4 text-light h2">
        <span class="test-header-color h4" v-if="app_env !== 'production'">
          【テスト環境】
        </span>
      </span>
      <b-nav-item-dropdown
        :text="this.config.projectName"
        class="list-unstyled mb-0 h2"
        :toggle-class="['header-image-upload-btn', 'text-light']"
        menu-class="main-color"
        no-caret
        v-if="!routePath()">
        <b-dropdown-item-button :button-class="['text-light', 'main-color-hover']" @click="moveToProjectList()">制作案件一覧</b-dropdown-item-button>
        <b-dropdown-item-button :button-class="['text-light', 'main-color-hover']" @click="moveToProjectList('dataList')">発注データ作成</b-dropdown-item-button>
        <b-dropdown-item-button :button-class="['text-light', 'main-color-hover']" @click="moveOrderList()">発注履歴</b-dropdown-item-button>
      </b-nav-item-dropdown>
      <div class="mb-0 h2 nav-link" style="color:white" v-else>
        {{this.config.projectName}}
      </div>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav mr-auto"></ul>
        <span class="navbar-text">
          <button class="btn btn-outline-light" @click.stop.prevent="logout()">ログアウト</button>
        </span>
      </div>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'ManagementHeader',
  methods: {
    logout () {
      this.$router.push('/login')
    },
    routePath () {
      return (this.$route.path.indexOf('/project_list') !== -1 || this.$route.path.indexOf('/order_list') !== -1)
    },
    moveToProjectList (listType) {
      var targetPath = '/project_list'
      if (this.$route.path.indexOf(targetPath) === -1) {
        if (listType) {
          targetPath += '?list_type=' + listType
          // 特定の画面の場合、検索前の条件を復元する
          if (this.$route.path.indexOf('/aggregate_projects') !== -1) {
            localStorage.setItem('isPageBack', JSON.stringify(true))
          }
        } else {
          // 特定の画面の場合、検索前の条件を復元する
          if (this.$route.path.indexOf('/delivered_image') !== -1) {
            localStorage.setItem('isPageBack', JSON.stringify(true))
          }
        }
        this.$router.push(targetPath)
      }
    },
    moveOrderList () {
      this.$router.push('/order_list')
    }
  },
  data () {
    return {
      app_env: process.env.APP_ENV
    }
  }
}
</script>
<style scoped>
  .customer-info-label h2 {
    font-size: 1.5rem;
  }
  .nav-link:focus, .nav-link:hover {
    text-decoration: none;
  }
  #header-image-upload-btn {
    padding: 3px 10px;
    box-shadow: 0 0 0 2px #fff;
    border-radius: 5px;
    font-size: 1.10rem;
    color: #fff;
  }
  #header-image-upload-btn a {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ManagementHeader.vue